import { Injectable } from '@angular/core';
import { CpxApiErrorCodeDmpConnectEnum } from 'src/app/utils/interfaces/new/cpx-api-error-code-dmp-connect-enum';
import { CpxApiErrorCodeDmpConnectJs2Enum } from 'src/app/utils/interfaces/new/cpx-api-error-code-dmp-connect-js2-enum';
import { CpxApiErrorCodeWrapperJsEnum } from 'src/app/utils/interfaces/new/cpx-api-error-code-wrapper-js-enum';
import { CpxApiErrorTypeEnum } from 'src/app/utils/interfaces/new/cpx-api-error-type-enum';

export interface CpxApiError {
  typeLabel: string;
  codeLabel?: string;
  i_apiErrorType: number;
  i_apiErrorCode?: number;
  s_apiErrorDescription: string;
  s_apiErrorContext: string;
  s_apiErrorExtendedInformations: string;
  s_apiErrorDmpErrorCode: string;
  s_apiErrorDmpErrorDetails: string;
}

interface RawCpxApiError {
  i_apiErrorType: number;
  i_apiErrorCode: number;
  s_apiErrorDescription: string;
  s_apiErrorContext: string;
  s_apiErrorExtendedInformations: string;
  s_apiErrorDmpErrorCode: string;
  s_apiErrorDmpErrorDetails: string;
  s_apiErrorTypeDescription: string;
}

@Injectable({
  providedIn: 'root'
})
export class CpxApiErrorService {

  constructor() { }

  public getError(rawError: RawCpxApiError): CpxApiError {
    let rtd: CpxApiError = undefined;
    if (rawError.i_apiErrorType === 5000) {
      rtd = {
        i_apiErrorType: rawError.i_apiErrorType,
        typeLabel: rawError.s_apiErrorTypeDescription,
        i_apiErrorCode: rawError.i_apiErrorCode,
        codeLabel: this._getCodeLabel(rawError.i_apiErrorCode, CpxApiErrorCodeDmpConnectJs2Enum),
        s_apiErrorContext: rawError.s_apiErrorContext,
        s_apiErrorDescription: rawError.s_apiErrorDescription,
        s_apiErrorDmpErrorCode: rawError.s_apiErrorDmpErrorCode,
        s_apiErrorDmpErrorDetails: rawError.s_apiErrorDmpErrorDetails,
        s_apiErrorExtendedInformations: rawError.s_apiErrorExtendedInformations,
      };
    } else if (rawError.i_apiErrorType === 6000) {
      rtd = {
        i_apiErrorType: rawError.i_apiErrorType,
        typeLabel: rawError.s_apiErrorTypeDescription,
        i_apiErrorCode: rawError.i_apiErrorCode,
        codeLabel: this._getCodeLabel(rawError.i_apiErrorCode, CpxApiErrorCodeWrapperJsEnum),
        s_apiErrorContext: rawError.s_apiErrorContext,
        s_apiErrorDescription: rawError.s_apiErrorDescription,
        s_apiErrorDmpErrorCode: rawError.s_apiErrorDmpErrorCode,
        s_apiErrorDmpErrorDetails: rawError.s_apiErrorDmpErrorDetails,
        s_apiErrorExtendedInformations: rawError.s_apiErrorExtendedInformations,
      };
    } else {
      rtd = {
        i_apiErrorType: rawError.i_apiErrorType,
        typeLabel: rawError.s_apiErrorTypeDescription,
        i_apiErrorCode: rawError.i_apiErrorCode,
        codeLabel: this._getCodeLabel(rawError.i_apiErrorCode, CpxApiErrorCodeDmpConnectEnum),
        s_apiErrorContext: rawError.s_apiErrorContext,
        s_apiErrorDescription: rawError.s_apiErrorDescription,
        s_apiErrorDmpErrorCode: rawError.s_apiErrorDmpErrorCode,
        s_apiErrorDmpErrorDetails: rawError.s_apiErrorDmpErrorDetails,
        s_apiErrorExtendedInformations: rawError.s_apiErrorExtendedInformations,
      };
    }

    return rtd;
  }

  private _getCodeLabel(code: number, e: any): string {
    const strArr: Array<string> = [];
    const indexArr: Array<number> = [];

    Object.keys(e).filter((v: any) => {
      if (isNaN(Number(v))) {
        strArr.push(v);
      } else {
        indexArr.push(Number(v));
      }
    });

    return strArr[indexArr.findIndex(i => i === code)];
  }
}
